"use client";

import Link from "next/link";
import { useEffect } from "react";

export default function WebError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[web/error.tsx]", {
      url: typeof window !== "undefined" ? window.location.href : undefined,
      digest: error.digest,
      message: error.message,
      stack: error.stack,
      error,
    });
  }, [error]);

  return (
    <div className="container py-8 space-y-8">
      <div className="prose">
        <h1>Hoppsan - något gick fel!</h1>
        <p>
          Vi har för närvarande tekniska problem och arbetar aktivt med att lösa
          dem så snabbt som möjligt. Vänligen försök igen om en stund.
        </p>
      </div>

      <Link className="btn" href="/">
        Tillbaka till startsidan
      </Link>
    </div>
  );
}
